// extracted by mini-css-extract-plugin
module.exports = {"refundsList":"SourceRefundsList_refundsList__1Regn"};